import React, { useState, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom';
import { MyContainer } from '../../components/common/MyContainer';
import Footer from '../../components/footer';
import Header from '../../components/header';
import {TitleTimeHome} from '../home/homeElements'
import {
    PageTitle,
    PageTitleLeft,
    CategoryName,
    PageTitleRight,
} from '../detailNews/detailNewsElements'
import Grid from '@material-ui/core/Grid';
import CategoryFocus from '../../components/categoryFocus';
import queryString from 'query-string';
import {
    PaddingRight,
    PaddingLeft
} from './categoryElements'
import HighlightBox from '../../components/highlightBox'
import {
    BorderLine,
    TitleBoxWrap,
    BoxHeader,
    BoxTitle
} from '../home/homeElements'
import NewsNewBox from '../../components/newsNewBox';
import MostViewBox from '../../components/mostViewBox';

export const SELECT_CATEGORY_OPTIONS = [
    { value: 'Thời sự', label: 'Thời sự' },
    { value: 'Thế giới', label: 'Thế giới' },
    { value: 'Pháp luật', label: 'Pháp luật' },
    { value: 'Kinh doanh', label: 'Kinh doanh' },
    { value: 'Công nghệ', label: 'Công nghệ' },
    { value: 'Xe', label: 'Xe' },
    { value: 'Du lịch', label: 'Du lịch' },
    { value: 'Nhịp sống trẻ', label: 'Nhịp sống trẻ' },
    { value: 'Văn hóa', label: 'Văn hóa' },
    { value: 'Giải trí', label: 'Giải trí' },
    { value: 'Thể thao', label: 'Thể thao' },
    { value: 'Giáo dục', label: 'Giáo dục' },
    { value: 'Khoa học', label: 'Khoa học' },
    { value: 'Sức khỏe', label: 'Sức khỏe' },
    { value: 'Giả-Thật', label: 'Giả-Thật' },
    { value: 'Bạn đọc', label: 'Bạn đọc' },
]

const validCategory = ['Thời sự', 'Thế giới', 'Pháp luật', 'Kinh doanh', 
'Công nghệ', 'Xe', 'Du lịch', 'Nhịp sống trẻ', 'Văn hóa', 'Giải trí', 
'Thể thao', 'Giáo dục', 'Khoa học', 'Sức khỏe', 'Giả-Thật', 'Bạn đọc']

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }

const Category = ({match}) => {
    const query = useQuery();
    const [time, setTime] = useState({})
    const category = query.get('category')
    const history = useHistory()
    
    useEffect(() => {
        !validCategory.includes(category) && history.push('/')
    }, [category, history])
    
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [category])

    useEffect(() => {
        const date = new Date();
        const dowArr = ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7']

        setTime({
            dow: dowArr[date.getDay()],
            day: date.getDate(),
            month: date.getMonth()+1,
            year: date.getFullYear()
        })
    }, [])

    
    
    return (
        <>
            <Header />
                <MyContainer>
                    <PageTitle>
                        <PageTitleLeft>
                            <CategoryName title={category} to={`/category/news?${queryString.stringify({category})}`}>{category}</CategoryName>
                        </PageTitleLeft>
                        <PageTitleRight>
                            <TitleTimeHome>{`${time.dow}, ngày ${time.day} tháng ${time.month} năm ${time.year}`}</TitleTimeHome>
                        </PageTitleRight>
                    </PageTitle>
                    <Grid style={{marginTop: '10px'}} container>
                        <Grid item md={12} lg={8}>
                            <PaddingRight>
                                <CategoryFocus category={category} />
                                <HighlightBox category={category} _limit={3} small />
                            </PaddingRight>
                        </Grid>
                        <Grid className='hide-on-mobile-tablet' item xs={4}>
                        <PaddingLeft>
                            <iframe title="banner" src="https://cdnstoremedia.com/adt/banners/nam2015/4043/min_html5/thuongphamthuy/2021_06_30/300x600_T6_129-3/300x600_T6_129/300x600_T6_129.html?url=%2F%2Flg1.logging.admicro.vn%2Fadn%3Fdmn%3Dhttps%253A%252F%252Ftuoitre.vn%252Fthoi-su.htm%26rid%3Dae3d7ea1-324e-459b-bf65-be47a7887db9121-60f02032%26ctr%3D1.500000013038516%26sspb%3D7500%26sspr%3D0.3183%26lsn%3D1626349611298%26ce%3D1%26lc%3D5%26cr%3D1625027409%26ui%3D2750274091907117133%26uuid%3De401684dc22bea82907ffa77362a622f%26bi%3D0%26cmpg%3D59194%26items%3D245974%26zid%3D511462%26pr%3D24612052795%26cid%3D-1%26tp%3D11%26tpn%3D4%26alg%3D10%26sspz%3D2011014%26adc_cpa%3D1%26cov%3D1%26re%3Dhttps%253A%252F%252Fad.doubleclick.net%252Fddm%252Ftrackclk%252FN993452.2464500ADMICROADNETWORK%252FB26006344.306667295%253Bdc_trk_aid%253D500474363%253Bdc_trk_cid%253D154052805%253Bdc_lat%253D%253Bdc_rdid%253D%253Btag_for_child_directed_treatment%253D%253Btfua%253D%253Bltd%253D&amp;admid=adnzone_511462_0_245974&amp;vast=https%3A%2F%2Fsspapi.admicro.vn%2Fssp_request%2Fvideo%3Fu%3Dtuoitre.vn%252Fthoi-su.htm%26z%3D511462%26p%3D1%26w%3D650%26h%3D300%26%26lsn%3Dc5be3c00d6a89aad8f13efdd508bdcda%26dgid%3D636b779a771444eb535cad65c0c6cdf4%26l%3D5%26loc%3D5%26i%3D2750274091907117133%26isdetail%3D0%26pid%3D%26tags%3D5%26adstype%3D%26vtype%3D8%26vid%3D%26bannerid%3D245974" width="300" height="600" frameBorder="0" scrolling="no"></iframe>
                        </PaddingLeft>
                        </Grid>
                    </Grid>
                    <BorderLine style={{marginTop: '20px'}} />
                    <TitleBoxWrap>
                        <BoxHeader>
                            <BoxTitle  to='/'>Tin mới</BoxTitle>
                        </BoxHeader>
                    </TitleBoxWrap>
                    <NewsNewBox viewmore _limit={10} skip={8} category={category} small />
                    <MostViewBox category={category} />
                </MyContainer>
            <Footer />
        </>
    )
}

export default Category
